module.exports = __webpack_public_path__ + "img/aParty_110523_F.f8f14216.jpg";